module.exports = __webpack_public_path__ + "img/glogo239.5ccb76ea.png";